__turbopack_context__.v({
  "actionButtonWrapper": "MainNavbar-module-scss-module__lwWs6a__actionButtonWrapper",
  "navActions": "MainNavbar-module-scss-module__lwWs6a__navActions",
  "navContainer": "MainNavbar-module-scss-module__lwWs6a__navContainer",
  "navLeftContainer": "MainNavbar-module-scss-module__lwWs6a__navLeftContainer",
  "navMiddleContainer": "MainNavbar-module-scss-module__lwWs6a__navMiddleContainer",
  "navRightContainer": "MainNavbar-module-scss-module__lwWs6a__navRightContainer",
  "navToggle": "MainNavbar-module-scss-module__lwWs6a__navToggle",
  "whiteLabeled": "MainNavbar-module-scss-module__lwWs6a__whiteLabeled",
});
